module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDkgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNyA3LjAzNDU5TDEgMTMuMDY5MiIgc3Ryb2tlPSIjOUE5QTlBIiBzdHJva2Utd2lkdGg9IjEuOCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/right-arrow-gray.svg
// module id = D0VT
// module chunks = 28